// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cc81f048","848":"50663e13"}[chunkId] + ".chunk.js";
};